// @ts-strict-ignore
import type { SerializedStyles } from "@emotion/serialize";
import { useTranslation } from "react-i18next";

import { Accordion, Checkbox } from "@aviary";
import { e2eAttributes } from "@shared/e2eAttributes";
import { FilterType } from "@shared/hooks/useAnalyticsLogger/useAnalyticsLogger";
import { useCatalogSearch } from "@shared/hooks/useCatalogSearch/useCatalogSearch";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { l } from "@shared/locales/i18n";

import { FilterTitle } from "../shared/FilterTitle/FilterTitle";

interface Props {
  isBold?: boolean;
  logFilterEvent: (entityName: string, entityType: string) => void;
  customAccordionStyle?: SerializedStyles[] | SerializedStyles;
}

const Availability = ({ isBold, logFilterEvent, customAccordionStyle }: Props) => {
  const { t } = useTranslation();
  const { isOnlyShowInStock, setIsOnlyShowInStock } = useCatalogSearch();
  const { isUnauthenticated } = useSharedGlobalConfig();

  if (isUnauthenticated) return null;

  const onChange = () => {
    if (!isOnlyShowInStock) {
      logFilterEvent("true", FilterType.AVAILABILITY);
    }

    const distanceFromTop = window?.scrollY;
    setIsOnlyShowInStock(!isOnlyShowInStock);
    requestAnimationFrame?.(() => window?.scrollTo(0, distanceFromTop));
  };

  return (
    <Accordion
      css={customAccordionStyle}
      data-e2e={e2eAttributes.availabilityFilter}
      coreTriggerContent={
        <FilterTitle
          title={t(l.sharedCatalog.filter.Availability)}
          count={Number(isOnlyShowInStock)}
          isBadge
          isSecondaryWeight={isBold}
        />
      }
    >
      <Checkbox
        data-e2e={e2eAttributes.inStockFilter}
        isFullWidth
        id="catalog-in-stock-checkbox"
        checked={!!isOnlyShowInStock}
        onChange={onChange}
      >
        {t(l.sharedCatalog.filter.InStock)}
      </Checkbox>
    </Accordion>
  );
};

export { Availability };
